import React, {useEffect, useState} from "react";
import debounce from "lodash/debounce";

export const useDebounceChange = (callBack) => {
    const [inputValue, setInputValue] = useState<string | null>(null);

    useEffect(() => {
        if (typeof inputValue !== 'string') return;

        const handleChangeDebounced = debounce(callBack, 500);
        handleChangeDebounced(inputValue);

        return () => {
            handleChangeDebounced.cancel();
        };
    }, [inputValue]);

    const handleDebounceChange = (value) => {
        setInputValue(value);
    };

    return {handleDebounceChange}
}